import { render } from "./MscopeNav.vue?vue&type=template&id=60477b18&scoped=true"
import script from "./MscopeNav.vue?vue&type=script&lang=js"
export * from "./MscopeNav.vue?vue&type=script&lang=js"

import "./MscopeNav.vue?vue&type=style&index=0&id=60477b18&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60477b18"]])

export default __exports__